export function isArray<TMaybeArray extends unknown[] | Readonly<unknown[]> | unknown>(
  arr: TMaybeArray
): arr is Extract<TMaybeArray, Readonly<unknown[]> | unknown[]> {
  return Array.isArray(arr)
}
